/* global Modernizr */

import { Controller } from 'stimulus';
import {
  getYoutubeId,
  createYoutubeEmbed,
  getYoutubePoster,
  getVimeoId,
  createVimeoEmbed,
  getVimeoPoster,
  getEmbedType,
} from '@/helpers/video';

const hasPoster = (target) => !!target.style.backgroundImage;
const isDesktop = () => Modernizr.mq('(min-width: 992px)');
const isTouchDevice = () => Modernizr.touchevents;

class Video extends Controller {
  connect() {
    this.addPosters();

    if (this.data.has('autoplay') && this.data.get('autoplay') === 'true') {
      this.loadVideo();
    }
  }

  onPosterClick(e) {
    e.preventDefault();

    if (!e.currentTarget.hasAttribute('data-prevent-popup') && isDesktop() && !isTouchDevice()) {
      this.openOverlay();
    }

    this.loadVideo();
  }

  loadVideo() {
    this.videoTarget.insertAdjacentHTML('beforeend', this.getEmbed());
    this.videoTarget.classList.add('is-loaded');

    setTimeout(() => {
      this.videoTarget.classList.add('is-playing');
    }, 400);
  }

  getEmbed() {
    const source = this.data.get('src');
    let embed;

    if (getEmbedType(source) === 'youtube') {
      const id = getYoutubeId(source);
      embed = createYoutubeEmbed(id);
    } else if (getEmbedType(source) === 'vimeo') {
      const id = getVimeoId(source);
      embed = createVimeoEmbed(id);
    }

    return embed;
  }

  addPosters() {
    const source = this.data.get('src');

    if (hasPoster(this.posterTarget)) {
      return;
    }

    if (getEmbedType(source) === 'youtube') {
      this.addYoutubePoster(getYoutubeId(source));
    } else if (getEmbedType(source) === 'vimeo') {
      this.addVimeoPoster(getVimeoId(source));
    }
  }

  addYoutubePoster(id) {
    this.addVideoPoster(getYoutubePoster(id));
  }

  addVimeoPoster(id) {
    getVimeoPoster(id, (src) => {
      this.addVideoPoster(src);
    });
  }

  addVideoPoster(poster) {
    this.posterTarget.style.backgroundImage = `url(${poster})`;
  }

  openOverlay() {
    this.element.classList.toggle('is-open');
  }

  closeOverlay(e) {
    if ((!e.target.closest('.video-block__close') && e.target.closest('.video-block__video'))
      || !this.element.classList.contains('is-open')) return;

    this.element.classList.remove('is-open');
    this.videoTarget.classList.remove('is-loaded', 'is-playing');

    if (this.hasIframeTarget) {
      this.iframeTarget.remove();
    }
  }
}

Video.targets = [
  'video',
  'poster',
  'iframe',
];

export default Video;
